/**
 * Riads, villas, hotels and the rest of the stay family — the only rows whose
 * price is a nightly rate rather than a per-person / per-hour / per-group one.
 *
 * Cards use this to swap the price glyph for an explicit "per night" lockup,
 * so web and mobile have to agree on what counts as a stay. `priceType` 2 is
 * the DB's per-night unit and is the reliable signal; `segment === "stays"`
 * covers explore rows that carry no category, and the category regex catches
 * bookable stay categories on payloads where priceType is missing.
 */
export function isStayItem(
  category?: string | null,
  segment?: string | null,
  priceType?: string | number | null,
): boolean {
  if (priceType === 2) return true;
  if ((segment ?? "").toLowerCase() === "stays") return true;
  const c = (category ?? "").toLowerCase();
  if (/(stay|hotel|riad|room|lodge|camp|villa|guesthouse|maison d'h|apartment)/.test(c)) return true;
  return /night|room|stay/.test(String(priceType ?? "").toLowerCase());
}
